import { render, staticRenderFns } from "./SettlementOrderTable.vue?vue&type=template&id=2baa9d3e&scoped=true&"
import script from "./SettlementOrderTable.vue?vue&type=script&lang=js&"
export * from "./SettlementOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./SettlementOrderTable.vue?vue&type=style&index=0&id=2baa9d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa9d3e",
  null
  
)

export default component.exports